import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import './index.css';
import './utils/i18n';
import App from 'app/App';
import { BrowserRouter } from 'react-router-dom';
import { OfflineProvider } from 'shared/contexts/OfflineContext';
import { initGoogleAdsTag } from 'utils/adsTracking';

function initNativeSystemBars(): void {
    if (!Capacitor.isNativePlatform()) return;
    void StatusBar.setOverlaysWebView({ overlay: true }).catch(() => {
        /* Android 15+: edge-to-edge is default; plugin may reject */
    });
    void StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
}

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element with id "root" was not found');
}

initNativeSystemBars();
initGoogleAdsTag();

const root = ReactDOM.createRoot(rootElement as HTMLElement);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <OfflineProvider>
                <App />
            </OfflineProvider>
        </BrowserRouter>
    </React.StrictMode>
);

